import * as React from 'react';
import { useAccountOrderCCurrencyCode } from '../../hooks';
import { ActorApiStringDisplay } from '../../../../../../components/display/string';

export const AccountOrderCCurrencyCode = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountOrderCCurrencyCode();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
    />
  );
};
